import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VLayout,{attrs:{"row":"","justify-center":""}},[_c(VDialog,{attrs:{"persistent":"","content":"","content-class":"centered-dialog"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c(VContainer,{attrs:{"fill-height":""}},[_c(VLayout,{attrs:{"column":"","justify-center":"","align-center":""}},[_c(VProgressCircular,{attrs:{"indeterminate":"","size":70,"width":7}}),(_vm.text != null)?_c('h1',[_vm._v(_vm._s(_vm.text))]):_vm._e()],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }